module.exports = __webpack_public_path__ + "media/images/users-18b908735727f9928ccfd3c7835444f1.svg";